const RightArrow = ({ color }: { color?: string }) => (
  <svg width="14" height="28" viewBox="0 0 14 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 1L12 14L2 27" stroke={color ?? '#383838'} stroke-width="3" />
  </svg>
);

export default RightArrow;
